
import ResourceDetail from '@shell/components/ResourceDetail/index.vue';

export default {
  name:       'KubewardenResourceCreate',
  components: { ResourceDetail },
};
